import {
	ACCESS_TOKEN,
	REFRESH_TOKEN,
	getToken,
} from '@contexts/Token.context.jsx';
import { api, deleteCookie, apiClient, unwrapV2Response } from './index.js';

export const getUserData = async () => {
	const token = getToken();
	if (!token) return null;
	
	const { data: apiResponse, error } = await apiClient.get('/v2/user');
	
	if (error) {
		throw new Error(error.message || 'Failed to fetch user data');
	}
	
	return unwrapV2Response(apiResponse);
};

export const updateUser = async ({ name, measurementSystem }) => {
	const { data } = await api.post('/users/update', {
		name,
		measurement_system: measurementSystem,
	});
	return data;
};

export const logoutUserOnServer = async () => {
	const { data } = await api.get('/auth/logout');

	if (data?.status !== 'success') {
		console.error('Error logging out user on the server', res);
	}
};

export const deleteUserCookiesFromBrowser = () => {
	deleteCookie(ACCESS_TOKEN);
	deleteCookie(REFRESH_TOKEN);
};

export const getUserTags = async () => {
	const { data } = await api.get('/users/tags');
	return data;
};

export const getUserStorage = async () => {
	const { data } = await api.get('/users/storage_usage');
	return data;
};
